import React, { useEffect, useState } from "react";
import loading_ from "../Assets2/loading.gif";
import { Line } from "react-chartjs-2";
import { deflate, inflate } from 'pako';

import Chart from "chart.js/auto";
import { set_tag_ids, set_tag_values } from "../Action/Action";
import "./CSS/All2.css";
import analy from "../Assets/6744989.png";
import speedr from "../Assets/3563394.png";
import steam from "../Assets/1724304.png";
import sun_energy from "../Assets/4114970.png";
import redbell from "../Assets/559343.png";
import pontoon from "../Assets/1505455.png";
import carbon_foot from "../Assets/7822060.png";
import Draggable from "react-draggable";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import GaugeChart from "react-gauge-chart";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import Store from "../Store/Store";

const LineChart = ({ data, labels, yAxisName }) => {
  const chartData = {
    labels: labels,
    datasets: [
      {
        label: "Random Data",
        data: data,
        fill: false,
        borderColor: "rgb(75, 192, 192)",
        tension: 0.1,
      },
    ],
  };
  const options = {
    scales: {
      x: {
        title: {
          display: true,
          text: "Zaman",
        },
      },
      y: {
        title: {
          display: true,
          text: yAxisName,
        },
      },
    },
  };

  return (
    <div>
      <Line options={options} data={chartData} />
    </div>
  );
};

const All2Edit = (props) => {
  const history = useHistory();

  const [toolbox_items, Set_toolbox_items] = useState([]);

  const [trends, Set_trends] = useState([])


  const [tool_box_length, Set_tool_box_length] = useState([]);

  const [tag_list_, SetTagList] = useState([]);
  const [tag_ids, SetTagIds] = useState([]);

  var tag_ids_ = [];

  const [trends_values, SettrendValues] = useState([]);

  const [pop_up_widget, Set_pop_up_widget] = useState([])

  var toplam___ = 0;

  const [times_for_trends, Set_times_for_trends] = useState(() => {
    var d = new Date();
    var hour = d.getHours();

    return [
      Number(hour - 3).toFixed(2),
      Number(hour).toFixed(2),
      Number(hour + 3).toFixed(2),
    ];
  });

  const op = setInterval(() => {
    Set_times_for_trends([]);
    var d = new Date();
    var hour = d.getHours();
    Set_times_for_trends((prevArray) => [
      ...prevArray,
      Number(hour - 3).toFixed(2),
    ]);
    Set_times_for_trends((prevArray) => [
      ...prevArray,
      Number(hour).toFixed(2),
    ]);
    Set_times_for_trends((prevArray) => [
      ...prevArray,
      Number(hour + 3).toFixed(2),
    ]);
  }, 60000);

  //const [selectedImage, setSelectedImage] = useState([]);

  const [fontSize, SetfontSize] = useState(0);
  const [fontFamily, SetfontFamily] = useState("");

  const [tag_flex_column, Set_tag_flex_column] = useState([])


  const [chartData, setChartData] = useState({
    labels: [], // X değerleri
    datasets: [
      {
        label: "Trend Verisi",
        data: [], // Y değerleri
        fill: false,
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 2,
      },
    ],
  });

  const [gaugeValue, Setgaugevalue] = useState(58); // A value between 0 and 1
  const [gaugeValueMax, SetgaugevalueMax] = useState(1);

  const [data, setData] = useState([]);

  const [labels_, Set_labels] = useState([])


  const exampleData = [
    { x: 0, y: 0 },
    { x: 1, y: 10 },
    { x: 2, y: 20 },
    { x: 3, y: 15 },
    // Add more data points as needed
  ];

  const [selectedImage, setSelectedImage] = useState([]);

  const [gauges, Set_gauges] = useState([])

  const [tag_btn, Settag_btn] = useState([]);
  const [white_spaces, Set_white_spaces] = useState([])

  const [links_btn, Set_links_btn] = useState([]);

  const [loading, SetLoading] = useState(true);
  const [w, SetW] = useState(285);
  const [h, SetH] = useState(320);
  const [resize_id, SetResizeID] = useState(null);
  const [ids, Setsids] = useState([]);
  const [path, setPath] = useState("");
  const [page_id, setPage_id] = useState(null);
  const [Toplam, setToplam] = useState(0);
  const [widgets, SetWidgets] = useState([]);
  const [pages, SetPages] = useState(props.pages__);
  const [page_Name, Set_page_Name] = useState("");

  let ids_2 = [];
  let bgs_var = [];

  const decompressData = (compressedData) => {
    console.log(compressedData);
    try {
      const decompressed = inflate(compressedData, { to: 'string' });
      return decompressed;
    } catch (error) {
      console.error('Decompression error:', error);
    }
  };


  const compressData = (data) => {
    try {
      const compressed = deflate(data, { to: 'string' });
      console.log(compressed);
      console.log(decompressData(compressed))
      return compressed;
    } catch (error) {
      console.error('Compression error:', error);
    }
  };


  let list = [];
  let control = loading;
  useEffect(() => {
    if (!control) {
      var returnString = window.location.pathname;
      returnString = returnString.replaceAll("/", "");
      returnString = returnString.replaceAll("_", " ");
      returnString = returnString.replaceAll("dashboard", "");
      returnString = returnString.replaceAll("edit", "");

      setPath(returnString);

      if (pages) {
        pages.forEach((item, index) => {
          if (item.details !== "") {
            item.details.Pages[0].text =
              item.details.Pages[0].text.toLowerCase();
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ö/g,
              "o"
            );
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ç/g,
              "c"
            );
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ş/g,
              "s"
            );
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ı/g,
              "i"
            );
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ğ/g,
              "g"
            );
            item.details.Pages[0].text = item.details.Pages[0].text.replace(
              /ü/g,
              "u"
            );

            if (item.details.Pages[0].text === returnString) {
              if (
                item.details.Pages[0].images_selected_pc_bg &&
                item.details.Pages[0].images_selected_pc_bg.length > 0
              ) {
                document.querySelector(
                  "section.all"
                ).style.backgroundImage = `url(${item.details.Pages[0].images_selected_pc_bg[0].src})`;
                document.querySelector("section.all").style.backgroundSize =
                  "contain";
                document.querySelector("section.all").style.backgroundPosition =
                  "top";
              } else {
                if (item.details.Pages[0].bgs) {
                  if (item.details.Pages[0].bgs.length > 0) {
                    let bg_picture = item.details.Pages[0].bgs[0].src
                    document.querySelector(
                      "section.all"
                    ).style.backgroundImage = `url(${bg_picture})`;
                    document.querySelector("section.all").style.backgroundSize =
                      "contain";
                    document.querySelector(
                      "section.all"
                    ).style.backgroundPosition = "center 200px";
                    document.querySelector("section.all").style.backgroundSize = "1200px";
                  }
                }
              }
            }
          }
        });
      }
    }
  }, [control]);

  const gaugeConfig = {
    // Configuration options (optional)
    arcWidth: 0.1,
    arcPadding: 0.02,
  };

  const [x_axis, Setx_axis] = useState("");
  const [y_axis, Sety_axis] = useState("");
  const [x_axis2, Setx_axis2] = useState("");
  const [y_axis2, Sety_axis2] = useState("");
  const [x_axis3, Setx_axis3] = useState("");
  const [y_axis3, Sety_axis3] = useState("");

  const [label1, Setlabel1] = useState([]);
  const [label2, Setlabel2] = useState([]);
  const [label3, Setlabel3] = useState([]);

  const [data1, Setdata1] = useState([]);
  const [data2, Setdata2] = useState([]);
  const [data3, Setdata3] = useState([]);


  const [images, Setimages] = useState([])


  const [texts, SetTexts] = useState([]);

  const [title_w, Set_title_w] = useState([]);
  const [text_box, Set_text_box] = useState([]);
  const [button2, Set_button2] = useState([])

  const [popup_state, Set_popup_state] = useState({})


  const charts = [
    { data: data1, labels: label1, xName: x_axis, yName: y_axis },
    { data: data2, labels: label2 },
    { data: data3, labels: label3 },
  ];

  const [trend_ids, Settrend_ids] = useState([]);



  useEffect(() => {
    const componentDidMount = async () => {
      setTimeout(() => {
        if (props.pages__.length > 0) {
          var toplam_ = 0;

          list = props.pages__;
          SetPages(props.pages__);

          var returnString = window.location.pathname;
          returnString = returnString.replaceAll("/", "");
          returnString = returnString.replaceAll("_", " ");
          returnString = returnString.replaceAll("dashboard", "");
          returnString = returnString.replaceAll("edit", "");

          setPath(returnString);
          console.log(props);

          if (props.pages__) {
            console.log(31313133);
            props.pages__.forEach((item, index) => {
              console.log(item);

              if (item.details !== "") {
                if (!("Pages" in item.details)) {
                  item.details = decompressData(item.details);
                  item.details = JSON.parse(item.details)
                }
                item.details.Pages[0].text =
                  item.details.Pages[0].text.toLowerCase();
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ö/g,
                  "o"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ç/g,
                  "c"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ş/g,
                  "s"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ı/g,
                  "i"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ğ/g,
                  "g"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ü/g,
                  "u"
                );
                item.details.Pages[0].text =
                  item.details.Pages[0].text.replaceAll("/", "");

                const dataFromDB = [
                  { x: 1, y: 10 },
                  { x: 2, y: 20 },
                  { x: 3, y: 15 },
                  // Diğer veriler...
                ];
                const labels = dataFromDB.map((point) => point.x);
                const values = dataFromDB.map((point) => point.y);

                setChartData({
                  ...chartData,
                  labels: labels,
                  datasets: [
                    {
                      ...chartData.datasets[0],
                      data: values,
                    },
                  ],
                });

                if (item.details.Pages[0].text === returnString) {
                  setPage_id(item.pageId);

                  if (item.details.Pages[0].images) {

                    var image_items = []

                    item.details.Pages[0].images.forEach((i) => {
                      if (typeof (i.src) === "string") {
                        Setsids((prevArray) => [...prevArray, { "id": i.id, "x": i.x, "y": i.y }]);
                        ids_2.push({ "id": i.id, "x": i.x, "y": i.y });
                        image_items.push(i)
                      } else {
                        Setsids((prevArray) => [...prevArray, { "id": i.id, "x": i.x, "y": i.y }]);
                        ids_2.push({ "id": i.id, "x": i.x, "y": i.y });
                        i.src = decompressData(Object.values(i.src))
                        console.log(i);
                        image_items.push(i)
                      }


                    })
                    Setimages(image_items)
                  }


                  if (item.details.Pages[0].widgets) {

                    var toplam____ = 0;
                    var gauge_w = []
                    var label_w = []
                    var tags_w = [];
                    var text_w = [];
                    var link_w = []
                    var trend_w = []
                    var white_w = [];
                    var title_w = [];
                    var text_box_w = [];
                    var btn2 = [];
                    var tag_flex_column_ = [];

                    item.details.Pages[0].widgets.forEach((j) => {
                      SetTagIds((prevArray) => [
                        ...prevArray,
                        { tagId: j.tagId },
                      ]);
                      tag_ids_.push({ "tagId": j.tagId });
                      Setsids((prevArray) => [...prevArray, { "id": j.id, "x": j.x, "y": j.y }]);
                      ids_2.push({ "id": j.id, "x": j.x, "y": j.y });


                      if (j.type === "gauge") {
                        gauge_w.push(j)
                      } else if (j.type === "trend") {
                        trend_w.push(j)
                      }
                      else if (j.type === "label") {
                        label_w.push(j)
                      } else if (j.type === "button") {
                        link_w.push(j)
                      } else if (j.type === "select") {
                        tags_w.push(j)
                      } else if (j.type === "text") {
                        text_w.push(j)
                      }
                      else if (j.type === "title") {
                        title_w.push(j)
                      } else if (j.type === "text_box") {
                        text_box_w.push(j)
                      }
                      else if (j.type === "pop_up_widget") {
                        btn2.push(j)
                      } else if (j.type === "tag") {
                        tag_flex_column_.push(j)
                      }
                    });

                    if (item.details.Pages[0].white_spaces && item.details.Pages[0].white_spaces.length > 0) {

                      item.details.Pages[0].white_spaces.forEach(k => {
                        console.log(k);
                        Setsids((prevArray) => [...prevArray, { "id": k.id, "x": k.x, "y": k.y }]);
                        ids_2.push({ "id": k.id, "x": k.x, "y": k.y });
                        white_w.push(k)
                      })

                    }
                    Set_gauges(gauge_w)
                    Set_trends(trend_w)
                    Set_labels(label_w)
                    SetTexts(text_w);
                    Set_links_btn(link_w)
                    Settag_btn(tags_w)
                    Set_white_spaces(white_w)
                    Set_title_w(title_w)
                    Set_text_box(text_box_w)
                    Set_button2(btn2)
                    Set_tag_flex_column(tag_flex_column_)


                  }

                  toplam_++;
                  SetLoading(false);
                  control = false;
                  setTimeout(async () => {
                    if (tag_ids_.length > 0) {

                      try {
                        const req_ = await fetch(
                          `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              accept: "application/json",
                            },
                            body: JSON.stringify(props.tag_ids), // Convert the body object to a JSON string
                          }
                        );
                        const response = await req_.json();
                        console.log(response);
                        SetTagList(response);
                        await Store.dispatch(set_tag_values(response));
                      } catch (err) {
                        console.log(err);
                      }
                    } else {
                      console.log("aa");
                    }
                  }, 100);
                }
              }
            });
          }
        } else {
        }
      }, 1200);
    };

    componentDidMount();

    setData(exampleData);
  }, [props.pages__]);

  useEffect(() => {
    const componentDidMount = async () => {
      setTimeout(() => {
        if (props.pages__.length > 0) {
          var toplam_ = 0;

          list = props.pages__;
          SetPages(props.pages__);

          var returnString = window.location.pathname;
          returnString = returnString.replaceAll("/", "");
          returnString = returnString.replaceAll("_", " ");
          returnString = returnString.replaceAll("dashboard", "");
          returnString = returnString.replaceAll("edit", "");

          setPath(returnString);
          console.log(props);

          if (props.pages__) {
            console.log(31313133);
            props.pages__.forEach((item, index) => {
              console.log(item);

              if (item.details !== "") {
                if (!("Pages" in item.details)) {
                  item.details = decompressData(item.details);
                  item.details = JSON.parse(item.details)
                }
                item.details.Pages[0].text =
                  item.details.Pages[0].text.toLowerCase();
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ö/g,
                  "o"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ç/g,
                  "c"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ş/g,
                  "s"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ı/g,
                  "i"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ğ/g,
                  "g"
                );
                item.details.Pages[0].text = item.details.Pages[0].text.replace(
                  /ü/g,
                  "u"
                );
                item.details.Pages[0].text =
                  item.details.Pages[0].text.replaceAll("/", "");

                const dataFromDB = [
                  { x: 1, y: 10 },
                  { x: 2, y: 20 },
                  { x: 3, y: 15 },
                  // Diğer veriler...
                ];
                const labels = dataFromDB.map((point) => point.x);
                const values = dataFromDB.map((point) => point.y);

                setChartData({
                  ...chartData,
                  labels: labels,
                  datasets: [
                    {
                      ...chartData.datasets[0],
                      data: values,
                    },
                  ],
                });

                if (item.details.Pages[0].text === returnString) {
                  setPage_id(item.pageId);

                  if (item.details.Pages[0].images) {

                    var image_items = []

                    item.details.Pages[0].images.forEach((i) => {
                      if (typeof (i.src) === "string") {
                        Setsids((prevArray) => [...prevArray, { "id": i.id, "x": i.x, "y": i.y }]);
                        ids_2.push({ "id": i.id, "x": i.x, "y": i.y });
                        image_items.push(i)
                      } else {
                        Setsids((prevArray) => [...prevArray, { "id": i.id, "x": i.x, "y": i.y }]);
                        ids_2.push({ "id": i.id, "x": i.x, "y": i.y });
                        i.src = decompressData(Object.values(i.src))
                        console.log(i);
                        image_items.push(i)
                      }


                    })
                    Setimages(image_items)
                  }


                  if (item.details.Pages[0].widgets) {

                    var toplam____ = 0;
                    var gauge_w = []
                    var label_w = []
                    var tags_w = [];
                    var text_w = [];
                    var link_w = []
                    var trend_w = []
                    var white_w = [];
                    var title_w = [];
                    var text_box_w = [];
                    var tag_flex_column_ = [];

                    item.details.Pages[0].widgets.forEach((j) => {
                      SetTagIds((prevArray) => [
                        ...prevArray,
                        { tagId: j.tagId },
                      ]);
                      tag_ids_.push({ "tagId": j.tagId });
                      Setsids((prevArray) => [...prevArray, { "id": j.id, "x": j.x, "y": j.y }]);
                      ids_2.push({ "id": j.id, "x": j.x, "y": j.y });


                      if (j.type === "gauge") {
                        gauge_w.push(j)
                      } else if (j.type === "trend") {
                        trend_w.push(j)
                      }
                      else if (j.type === "label") {
                        label_w.push(j)
                      } else if (j.type === "button") {
                        link_w.push(j)
                      } else if (j.type === "select") {
                        tags_w.push(j)
                      } else if (j.type === "text") {
                        text_w.push(j)
                      }
                      else if (j.type === "title") {
                        title_w.push(j)
                      } else if (j.type === "text_box") {
                        text_box_w.push(j)
                      } else if (j.type === "tag") {
                        tag_flex_column_.push(j)
                      }
                    });

                    if (item.details.Pages[0].white_spaces && item.details.Pages[0].white_spaces.length > 0) {

                      item.details.Pages[0].white_spaces.forEach(k => {
                        console.log(k);
                        Setsids((prevArray) => [...prevArray, { "id": k.id, "x": k.x, "y": k.y }]);
                        ids_2.push({ "id": k.id, "x": k.x, "y": k.y });
                        white_w.push(k)
                      })

                    }
                    Set_gauges(gauge_w)
                    Set_trends(trend_w)
                    Set_labels(label_w)
                    SetTexts(text_w);
                    Set_links_btn(link_w)
                    Settag_btn(tags_w)
                    Set_white_spaces(white_w)
                    Set_title_w(title_w)
                    Set_text_box(text_box_w)
                    Set_tag_flex_column(tag_flex_column_)


                  }
                  if (item.details.Pages[0].images_selected_pc) {
                    item.details.Pages[0].images_selected_pc.forEach((j) => {
                      console.log(item.details.Pages[0].images_selected_pc);
                      setSelectedImage((prevArray) => [...prevArray, j]);
                      Setsids((prevArray) => [...prevArray, j]);
                      ids_2.push(j);
                    });
                  }


                  toplam_++;
                  SetLoading(false);
                  control = false;
                  setTimeout(async () => {
                    if (tag_ids_.length > 0) {

                      try {
                        const req_ = await fetch(
                          `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues`,
                          {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/json",
                              accept: "application/json",
                            },
                            body: JSON.stringify(props.tag_ids), // Convert the body object to a JSON string
                          }
                        );
                        const response = await req_.json();
                        console.log(response);
                        SetTagList(response);
                        await Store.dispatch(set_tag_values(response));
                      } catch (err) {
                        console.log(err);
                      }
                    } else {
                      console.log("aa");
                    }
                  }, 10000);
                }
              }
            });
          }
        } else {
        }
      }, 1200);
    };

    componentDidMount();

    setData(exampleData);
  }, [window.location.pathname]);

  // setInterval(async () => {

  //   try {
  //     const req_ = await fetch(
  //       `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues`,
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           accept: "application/json",
  //         },
  //         body: JSON.stringify(props.tag_ids), // Convert the body object to a JSON string
  //       }
  //     );
  //     const response = await req_.json();
  //     SetTagList(response);
  //     toplam___++;
  //   } catch (err) {
  //     console.log(err);
  //   }

  // }, 5000);

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        title: {
          display: true,
          text: x_axis, // Replace with your X-axis label
        },
      },
      y: {
        title: {
          display: true,
          text: y_axis, // Replace with your Y-axis label
        },
      },
    },
  };

  const set_default_position_0 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "0") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };

  const set_default_position_1 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "1") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_2 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "2") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_3 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "3") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_4 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "4") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_5 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "5") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_6 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "6") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_7 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "7") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_8 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "8") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_9 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "9") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_10 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "10") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_11 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "11") {
        console.log(item);
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_12 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "12") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_13 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "13") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_14 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "14") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_15 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "15") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_16 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "16") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_17 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "17") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_18 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "18") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };


  const set_default_position_19 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "19") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_20 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "20") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_21 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "21") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_22 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "22") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_23 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "23") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_24 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "24") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_25 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "25") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_26 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "26") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_27 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "27") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_39 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "39") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_28 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "28") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_29 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "29") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_30 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "30") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_31 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "31") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_32 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "32") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_33 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "33") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_34 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "34") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_35 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "35") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_36 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "36") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_37 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "37") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_38 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "38") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_40 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "40") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_41 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "41") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_42 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "42") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_43 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "43") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_44 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "44") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_45 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "45") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_46 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "46") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_47 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "47") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_48 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "48") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_49 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "49") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_50 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "50") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_51 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "51") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_52 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "52") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_53 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "53") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_54 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "54") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_55 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "55") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_56 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "56") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_57 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "57") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_58 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "58") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_59 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "59") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_60 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "60") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_61 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "61") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_62 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "62") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_63 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "63") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_64 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "64") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_65 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "65") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_66 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "66") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_67 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "67") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_68 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "68") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_69 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "69") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_70 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "70") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_71 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "71") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_72 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "72") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_73 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "73") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_74 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "74") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_75 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "75") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_76 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "76") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_77 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "77") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_78 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "78") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_79 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "79") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_80 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "80") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_81 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "81") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_82 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "82") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_83 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "83") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_84 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "84") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_85 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "85") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_86 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "86") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_87 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "87") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_88 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "88") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_89 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "89") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_90 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "90") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_91 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "91") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_92 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "92") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_93 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "93") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_94 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "94") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };

  const set_default_position_95 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "95") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_96 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "96") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_97 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "97") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_98 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "98") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_99 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "99") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_100 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "100") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_101 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "101") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_102 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "102") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_103 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "103") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_104 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "104") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_105 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "105") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_106 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(item.id) === "106") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_107 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "107") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_108 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "108") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_109 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "109") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_110 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "110") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_111 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "111") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_112 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "112") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_113 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "113") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_114 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "114") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_115 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "115") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_116 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "116") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_117 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "117") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_118 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "118") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_119 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "119") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_120 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "120") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_121 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "121") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_122 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "122") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_123 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "123") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_124 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "124") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_125 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "125") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_126 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "126") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_127 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "127") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_128 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "128") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_129 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "129") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_130 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "130") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_131 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "131") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_132 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "132") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_133 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "133") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_134 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "134") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_135 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "135") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_136 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "136") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_137 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "137") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_138 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "138") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_140 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "140") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_139 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "139") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_141 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "141") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_142 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "142") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_143 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "143") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_144 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "144") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_145 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "145") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_146 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "146") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_147 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "147") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_148 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "148") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_149 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "149") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_150 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "150") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_152 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "152") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_151 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "151") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_153 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "153") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_154 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "154") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_155 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "155") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_156 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "156") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_157 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "157") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_158 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "158") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_159 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "159") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_160 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "160") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_161 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "161") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_162 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "162") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_163 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "163") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_164 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "164") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_165 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "165") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_166 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "166") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_167 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "167") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_168 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "168") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_194 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "194") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_169 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "169") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_170 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "170") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_171 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "171") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_172 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "172") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_173 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "173") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_174 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "174") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_175 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "175") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_176 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "176") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_177 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "177") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_178 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "178") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_179 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "179") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_180 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "180") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_181 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "181") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_182 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "182") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_183 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "183") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_184 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "184") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_185 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "185") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_186 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "186") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_187 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "187") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_188 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "188") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_189 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "189") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_190 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "190") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_191 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "191") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_192 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "192") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_193 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "193") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_201 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "201") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_195 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "195") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_196 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "196") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_197 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "197") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_198 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "198") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_199 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "199") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };
  const set_default_position_200 = () => {
    var x = 0,
      y = 0;
    ids.forEach((item) => {
      if (String(String(item.id)) === "200") {
        x = Number(item.x);
        y = Number(item.y);
      }
    });
    return { x, y };
  };


  const delete_btn_click = (e) => {
    e.preventDefault();
    var seleceted_id = e.target.parentElement.id;
    var newdata1 = pages;
    var newdata2 = [];
    var newdata3 = [];
    var newdata4 = [];

    var text;
    props.pages__.forEach((i) => {
      if (i.pageId === page_id) {
        text = i.pageName;
      }
    });

    var confirm = window.confirm(
      "Bu elemanı silmek istediğinize emin misiniz?"
    );

    if (confirm) {
      console.log(newdata1);
      newdata1.forEach((item, index) => {
        if (item.details !== "") {
          if (item.details.Pages[0].text === path) {
            if (item.details.Pages[0].widgets) {
              item.details.Pages[0].widgets.forEach((i) => {
                if (String(i.id) !== seleceted_id) {
                  newdata2.push(i);
                  console.log(newdata2);
                }
              });
            }
            if (item.details.Pages[0].images) {
              item.details.Pages[0].images.forEach((j) => {
                if (String(j.id) !== seleceted_id) {
                  newdata3.push(j);
                }
              });
            }
            if (item.details.Pages[0].white_spaces) {
              item.details.Pages[0].white_spaces.forEach((k) => {
                if (String(k.id) !== seleceted_id) newdata4.push(k)
              })
            }

            item.details.Pages[0].widgets = newdata2;
            item.details.Pages[0].images = newdata3;
            item.details.Pages[0].white_spaces = newdata4
          }
        }
      });
      console.log(newdata1);
      newdata1.forEach(async (i) => {
        if (i.pageId === page_id) {
          try {
            const req_ = await fetch(
              `https://app-rmmsapi.azurewebsites.net/api/pages/AddPage`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  accept: "application/json",
                },
                body: JSON.stringify({
                  PageId: page_id,
                  pageName: text,
                  details: JSON.stringify(i.details),
                  companyId: props.company_id,
                }), // Convert the body object to a JSON string
              }
            );
            const response = await req_.json();
            console.log(response);
          } catch (err) {
            console.log(err, "aüaüaüaüaüaüüaaü");
          }
        }
      });
      e.target.parentElement.style.opacity = "0";
    }
  };
  const [control_save, Setcontrol_save] = useState(false);

  const OnDragChange = async (e, data) => {
    console.log(pages);
    var dom_ = document.querySelector(".save_edit_changes_p");
    document.querySelector(".sv_changes_kapsayici").style.display = "none";
    if (!dom_.classList.contains("save_edit_changes_p_active")) {
      dom_.classList.add("save_edit_changes_p_active");
    }
    const { x, y } = data;
    const { id } = data.node;
    console.log(id, x, y, data);
    let newdata = [];
    for (let i = 0; i < ids.length; i++) {
      if (String(ids[i].id) === String(id)) {
        newdata = [...ids];
        newdata[i].x = x;
        newdata[i].y = y;
        Setsids(newdata);
      }
    }
    console.log(list);

    var text;
    props.pages__.forEach((i) => {
      if (i.pageId === page_id) {
        text = i.pageName;
      }
    });

    let newdata2 = [...pages];
    newdata2.forEach(async (item) => {
      if (item.details !== "") {
        var text__ = item.details.Pages[0].text;
        // await dispatch(pages_name_add(text__))
        text__ = text__.toLowerCase();
        text__ = text__.replace(/ö/g, "o");
        text__ = text__.replace(/ç/g, "c");
        text__ = text__.replace(/ş/g, "s");
        text__ = text__.replace(/ı/g, "i");
        text__ = text__.replace(/ğ/g, "g");
        text__ = text__.replace(/ü/g, "u");
        if (text__ === path) {
          if (item.details.Pages[0].images) {

            item.details.Pages[0].images.forEach((i) => {
              if (String(i.id) === String(id)) {
                i.x = x;
                i.y = y;
              }

            });
          }
          if (item.details.Pages[0].white_spaces) {
            var new_arr = []
            var newdata1_1;

            console.log("3111111111111111111111111111111111");
            newdata1_1 = white_spaces



            item.details.Pages[0].white_spaces.forEach((i) => {
              if (String(i.id) === String(id)) {
                i.x = x;
                i.y = y;
              }
            })
            newdata1_1.forEach((i) => {
              if (String(i.id) === String(id)) {
                i.x = x;
                i.y = y;
              }
            })
            Set_white_spaces(newdata1_1)
          }
          if (item.details.Pages[0].widgets) {
            item.details.Pages[0].widgets.forEach((j) => {
              if (String(j.id) === String(id)) {
                j.x = x;
                j.y = y;
              }
            });
          }
          list = newdata2;
        }
      }
    });
    SetPages(newdata2)
    // list.forEach(async i => {
    //     if (i.pageId === page_id) {
    //         try {
    //             const req_ = await fetch(`api/pages/AddPage`, {
    //                 method: 'POST',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                     "accept": "application/json"
    //                 },
    //                 body: JSON.stringify({
    //                     "PageId": page_id,
    //                     "pageName": text,
    //                     "details": JSON.stringify(i.details)
    //                 }) // Convert the body object to a JSON string
    //             })
    //             const response = await req_.json()
    //             console.log(response);
    //         } catch (err) {
    //             console.log(err, "aüaüaüaüaüaüüaaü");
    //         }
    //     }
    // })

    console.log(newdata2);
  };

  // const delete_bg = e => {
  //     let section_all = document.querySelector("section.all")
  //     section_all.style.backgroundImage = "none"
  //     var newdata = list

  //     newdata.forEach(i => {
  //         if (i.pageId === Number(page_id)) {
  //             i.details = []
  //         }
  //     })

  //     newdata.forEach(async i => {
  //         if (i.pageId === page_id) {
  //             try {
  //                 const req_ = await fetch(`api/pages/AddPage`, {
  //                     method: 'POST',
  //                     headers: {
  //                         'Content-Type': 'application/json',
  //                         "accept": "application/json"
  //                     },
  //                     body: JSON.stringify({
  //                         "PageId": page_id,
  //                         "pageName": text,
  //                         "details": JSON.stringify(i.details)
  //                     }) // Convert the body object to a JSON string
  //                 })
  //                 const response = await req_.json()
  //                 console.log(response);
  //             } catch (err) {
  //                 console.log(err, "aüaüaüaüaüaüüaaü");
  //             }
  //         }
  //     })

  //     newdata.forEach(i => {
  //         if (i.id === Number(page_id)) {
  //             i.bgs = []
  //         }
  //     })

  //     databasefirebase.ref(`${props.auth_reducer}/Pages`).set(newdata)

  // }

  const close_vrf_pop_up = () => {
    document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")
    Set_popup_state({})
  }

  const close_resize_image = () => {
    let section = document.querySelector("section.all");
    if (section.classList.contains("section_dark")) {
      section.classList.remove("section_dark");
    }
    const widgets = document.querySelector(".sv_changes_kapsayici");
    widgets.classList.toggle("is-active");
  };

  const save_font_p = async (e, size, family) => {
    e.preventDefault();
    let newdata2 = [...pages];
    let id_ = e.target.parentElement.parentElement.parentElement.id;

    var text;
    props.pages__.forEach((i) => {
      if (i.pageId === page_id) {
        text = i.pageName;
      }
    });

    for (let item of newdata2) {
      var text__ = item.details.Pages[0].text;
      // await dispatch(pages_name_add(text__))
      text__ = text__.toLowerCase();
      text__ = text__.replace(/ö/g, "o");
      text__ = text__.replace(/ç/g, "c");
      text__ = text__.replace(/ş/g, "s");
      text__ = text__.replace(/ı/g, "i");
      text__ = text__.replace(/ğ/g, "g");
      text__ = text__.replace(/ü/g, "u");
      if (text__ === path) {
        if (item.details.Pages[0].widgets) {
          item.details.Pages[0].widgets.forEach((i) => {
            if (String(i.id) === id_) {
              console.log(89);
              i.fontSize = size;
              i.fontFamily = family;
            }
          });
        }
        list = newdata2;
      }
    }
    list.forEach(async (i) => {
      if (i.pageId === page_id) {
        try {
          const req_ = await fetch(
            `https://app-rmmsapi.azurewebsites.net/api/pages/AddPage`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
                accept: "application/json",
              },
              body: JSON.stringify({
                PageId: page_id,
                userId: props.auth_reducer,
                pageName: text,
                details: JSON.stringify(i.details),
                companyId: props.company_id,
              }), // Convert the body object to a JSON string
            }
          );
          const response = await req_.json();
          console.log(response);
        } catch (err) {
          console.log(err, "aüaüaüaüaüaüüaaü");
        } finally {
          window.location.reload();
        }
      }
    });
  };

  useEffect(() => {
    console.log(selectedImage, "awawaw");
  }, [selectedImage]);

  const save_image_size = async (e) => {
    e.preventDefault();
    let id_ = e.target.parentElement.parentElement.id;
    console.log(id_);

    let newdata = ids;
    newdata.forEach((item, index) => {
      if (item.id === id_) {
        item.w = Number(w);
        item.h = Number(h);
      }
    });
    var text;
    props.pages__.forEach((i) => {
      if (i.pageId === page_id) {
        text = i.pageName;
      }
    });
    Setsids(newdata);
    let newdata2 = [...pages];
    try {
      for (let item of newdata2) {
        var text__ = item.details.Pages[0].text;
        // await dispatch(pages_name_add(text__))
        text__ = text__.toLowerCase();
        text__ = text__.replace(/ö/g, "o");
        text__ = text__.replace(/ç/g, "c");
        text__ = text__.replace(/ş/g, "s");
        text__ = text__.replace(/ı/g, "i");
        text__ = text__.replace(/ğ/g, "g");
        text__ = text__.replace(/ü/g, "u");
        if (text__ === path) {
          if (item.details.Pages[0].images) {
            item.details.Pages[0].images.forEach((i) => {
              if (String(i.id) === id_) {
                i.w = Number(w);
                i.h = Number(h);
              }
            });
          }
          if (item.details.Pages[0].images_selected_pc) {
            item.details.Pages[0].images_selected_pc.forEach((i) => {
              if (String(i.id) === id_) {
                i.w = Number(w);
                i.h = Number(h);
              }
            });
          }
          list = newdata2;
          list.forEach(async (i) => {
            if (i.pageId === page_id) {
              try {
                control = true;
                SetLoading(true);
                const widgets = document.querySelector(".sv_changes_kapsayici");
                widgets.classList.toggle("is-active");
                const req_ = await fetch(
                  `https://app-rmmsapi.azurewebsites.net/api/pages/AddPage`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      accept: "application/json",
                    },
                    body: JSON.stringify({
                      PageId: page_id,
                      userId: props.auth_reducer,
                      pageName: text,
                      details: JSON.stringify(i.details),
                      companyId: props.company_id,
                    }), // Convert the body object to a JSON string
                  }
                );
                const response = await req_.json();
                console.log(response);
              } catch (err) {
                console.log(err, "aüaüaüaüaüaüüaaü");
              } finally {
                window.location.reload();
              }
            }
          });
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      SetfontSize(null);
      SetfontFamily(null);
    }
  };


  const resizeImageWidget = (w, h, id, e) => {
    SetW(w);
    SetH(h);
    SetResizeID(id);
    let section = document.querySelector("section.all");
    section.classList.toggle("section_dark");
    document.querySelector(".sv_changes_kapsayici").style.display = "flex";
    document
      .querySelector(".sv_changes_kapsayici")
      .classList.toggle("is-active");
  };

  const getGaugeColor = (percent) => {
    if (percent >= 0.7) {
      return "#00FF00"; // Green color for values >= 70%
    } else if (percent >= 0.3) {
      return "#FFFF00"; // Yellow color for values >= 30%
    } else {
      return "#FF0000"; // Red color for values < 30%
    }
  };

  const get_tag_value_btn = async (id_) => {
    var data = [{

      tagId: id_
    }]

    var obj = {
      "tagValue": "",
      "tagName": "",
      "Type": "",
      "Data_Type": "",
      "Major_address": "",
      "Minor_address": "",
      "tagId": "",
      "DB_Number": ""
    }

    try {
      const req_ = await fetch(
        `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagValues`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },

          body: JSON.stringify(data), // Convert the body object to a JSON string
        }
      );
      const response = await req_.json();
      if (response.length > 0) {
        obj.tagValue = response[0].tagValue
      }

      const req_2 = await fetch(
        `https://app-rmmsapi.azurewebsites.net/api/tags/GetTagList`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            accept: "application/json",
          },

          body: JSON.stringify({
            "companyId": 1
          }), // Convert the body object to a JSON string
        }
      );
      const response2 = await req_2.json();
      if (response2.length > 0) {
        for (let i = 0; i < response2.length; i++) {
          if (String(response2[i].tagId) === String(id_)) {
            obj.DB_Number = response2[i].tagDbNumber;
            obj.Type = response2[i].tagType;
            obj.Data_Type = response2[i].tagDataType;
            obj.tagName = response2[i].tagName;
            obj.Major_address = response2[i].tagAddress;
            obj.Minor_address = response2[i].tagAddressDetail;
            obj.tagId = response2[i].tagId;

          }
        }
      }

      Set_popup_state(obj)
      console.log(obj);
    } catch (error) {
      console.log(error);
    }

  }


  const saveTheChangesOfEdit = () => {
    console.log(pages);
    var dom_ = document.querySelector(".save_edit_changes_p");
    if (dom_.classList.contains("save_edit_changes_p_active")) {
      dom_.classList.remove("save_edit_changes_p_active");
    }
    var text;
    props.pages__.forEach((i) => {
      if (i.pageId === page_id) {
        text = i.pageName;
      }
    });
    let newdata2 = [...pages];
    console.log(newdata2);
    for (let item of newdata2) {
      console.log((item.details));

      if (item.details !== "") {
        var text__ = item.details.Pages[0].text;
        // await dispatch(pages_name_add(text__))
        text__ = text__.toLowerCase();
        text__ = text__.replace(/ö/g, "o");
        text__ = text__.replace(/ç/g, "c");
        text__ = text__.replace(/ş/g, "s");
        text__ = text__.replace(/ı/g, "i");
        text__ = text__.replace(/ğ/g, "g");
        text__ = text__.replace(/ü/g, "u");
        if (text__ === path) {
          list = newdata2
          list.forEach(async (i) => {
            if (i.pageId === page_id) {
              try {
                control = true;
                Setcontrol_save(false);
                SetLoading(true);
                const widgets = document.querySelector(".sv_changes_kapsayici");
                widgets.classList.toggle("is-active");


                console.log(i.details);
                // var new_arr = []
                // i.details.Pages[0].white_spaces.forEach(x => {
                //   var new_arr2 = []
                //   Object.entries(x).forEach(([key, values]) => {
                //     new_arr2.push(values)
                //   })
                //   new_arr.push(JSON.parse(decompressData(new_arr2)))
                // })

                // console.log(new_arr);
                //
                const req_ = await fetch(
                  `https://app-rmmsapi.azurewebsites.net/api/pages/AddPage`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                      accept: "application/json",
                    },
                    body: JSON.stringify({
                      PageId: page_id,
                      pageName: text,
                      userId: props.auth_reducer,
                      details: JSON.stringify(i.details),
                      companyId: props.company_id,
                    }), // Convert the body object to a JSON string
                  }
                );
                const response = await req_.json();
                console.log(response, req_.status);
              } catch (err) {
                console.log(err, "aüaüaüaüaüaüüaaü");
              } finally {
                history.push("/");
              }
            }
          });
        }
      }
    }
  };


  toplam___ = 0;

  var sayac = 0;


  const set_default_position = (id) => {
    var x = 0, y = 0;
    ids.forEach((item) => {
      if (String(item.id) === String(id)) {
        x = Number(item.x);
        y = Number(item.y);
      }
    });


    return { x, y };
  };


  return (
    <>
      <div className="bottom-nav-3">
        <span style={{ color: "rgb(90,90,90)", fontSize: "18px", fontWeight: "500" }}>{props.pathname.slice(1)}</span>
        <Link className="add_all_3" to={`/dashboard/${page_id}/add`}>
          Add <i className="fas fa-edit"></i>
        </Link>
      </div>
      <div className="sv_changes_kapsayici">
        <div
          style={{ marginTop: "12px" }}
          id={resize_id}
          className="change_the_img_size_widget"
        >
          <i
            onClick={close_resize_image}
            style={{
              width: "100%",
              float: "left",
              marginBottom: "8px",
              fontSize: "24px",
              color: "red",
              position: "relative",
              left: "90%",
            }}
            className="fas fa-times"
          ></i>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
            className="row"
          >
            <p style={{ marginRight: "12px", fontWeight: 600 }}>Width:</p>
            <input
              type="text"
              onChange={(e) => {
                SetW(e.target.value);
              }}
              value={w}
              style={{ padding: "12px", border: "1px solid #ccc" }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "space-around",
            }}
            className="row"
          >
            <p style={{ marginRight: "12px", fontWeight: 600 }}>Height:</p>
            <input
              type="text"
              value={h}
              onChange={(e) => {
                SetH(e.target.value);
              }}
              style={{ padding: "12px", border: "1px solid #ccc" }}
            />
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "12px",
            }}
            className="sv_changes"
          >
            <button
              onClick={save_image_size}
              style={{
                cursor: "pointer",
                padding: "12px",
                backgroundColor: "green",
                border: "none",
                color: "#fff",
              }}
            >
              Save Changes
            </button>
          </div>
        </div>
      </div>

      {loading === true ? (
        <div
          style={{
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          className="loading"
        >
          <img style={{ width: "15%" }} src={loading_} alt="" />
        </div>
      ) : (
        <section className="all">
          <div id="images_grid_all_2" className="images-grid">
            {images.map((item, index) => {
              var left_positioN_distance = item.w * 130 / 220

              console.log(item);


              return (
                <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                  <div id={`${item.id}`}>
                    <button
                      onClick={delete_btn_click}
                      className="all_2_delete_btn"
                    >
                      Delete
                    </button>
                    <button
                      style={{
                        left: `${left_positioN_distance}px`
                      }}
                      onClick={() => {
                        resizeImageWidget(item.w, item.h, item.id);
                      }}
                      className="resize_img_btn"
                    >
                      Resize
                    </button>
                    <img src={item.src} style={{ width: `${item.w}px`, height: `${item.h}px` }} id={item.id} />
                  </div>
                </Draggable>
              )
            })}
          </div>

          {gauges.map((item, index) => {
            console.log(item);
            console.log(props.tag_values);
            let percent = Number(Number(props.tag_values.filter(x => String(x.tagId) === String(item.tagId)).map(x => x.tagValue)).toFixed(2) / Number(item.max_value));
            var değer = props.tag_values.filter(x => String(x.tagId) === String(item.tagId)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))
            let tag_name;
            if (item.tagName.length > 20) {
              tag_name = item.tagName.slice(0, 17)
            }
            return (
              <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                <div id={item.id}>
                  <button
                    style={{
                      top: "-25%",
                      padding: "4px",
                      zIndex: "100000000000000000000"
                    }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>
                  <div title={item.tagName}>
                    <div
                      style={{
                        maxWidth: "120px",
                        backgroundColor: "rgb(240,240,240)",
                        border: "2px solid rgb(40,40,40)",
                        padding: "4px 0px",
                      }}
                      id={index}
                    >
                      <GaugeChart
                        style={{ maxWidth: "120px" }}
                        arcColor={getGaugeColor(percent)}
                        id="gauge-chart"
                        percent={percent}
                        {...gaugeConfig}
                      />
                      <div className="gauge_values_display_page">
                        <span style={{ fontSize: "13px", fontWeight: "600" }}>0</span>
                        <span style={{ fontFamily: "Segoe UI', Tahoma, Geneva, Verdana, sans-serif", color: "chocolate", position: "relative", left: "4px" }}>{değer}</span>
                        <span style={{ fontSize: "13px", fontWeight: "600" }}>{Number(item.max_value)}</span>
                      </div>
                      <span className="gauge_name_tag">{tag_name}</span>

                    </div>
                  </div>
                </div>
              </Draggable>
            );
          })}

          {trends.map((item, index) => {
            console.log(item);
            var data_ = []
            var date = new Date()
            var labels__ = []
            var toplam = 0
            var k = 0;
            while (k < 3) {
              props.tag_values.forEach(i => {
                if (String(item.tagId) === String(i.tagId)) {
                  data_.push(i.tagValue)
                  labels__.push(`${date.toISOString().slice(0, 16)}`)
                }
                toplam++
              })
              k++
              console.log("data", data_);
            }



            return (
              <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                <div id={item.id}>
                  <div className='set_prop_right_click_area'  >
                    <button
                      onClick={delete_btn_click}
                      className="all_2_delete_btn"
                    >
                      Delete
                    </button>
                    <div className="widget_ucreated">

                      <div >
                        <div>
                          <LineChart yAxisName={item.axis_name} data={data_} labels={labels__} />
                        </div>

                      </div>

                    </div>
                  </div>
                </div>
              </Draggable>
            )
          })}

          {texts.map((item, index) => {
            console.log(item);
            return (
              <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                <div id={item.id}>
                  <button style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>
                  <span
                    type="text"

                    className="drag-input-text-all2edit"
                  >{item.title_widget}</span>
                </div>
              </Draggable>
            );
          })}

          {links_btn.map((item, index) => {
            console.log(item.page_name);
            var page_name2 = item.page_name
            var page_name =
              item.page_name.toLowerCase();
            page_name = page_name.replace(
              /ö/g,
              "o"
            );
            page_name = page_name.replace(
              /ç/g,
              "c"
            );
            page_name = page_name.replace(
              /ş/g,
              "s"
            );
            page_name = page_name.replace(
              /ı/g,
              "i"
            );
            page_name = page_name.replace(
              /ğ/g,
              "g"
            );
            page_name = page_name.replace(
              /ü/g,
              "u"
            );
            page_name = page_name.replaceAll("/", "");
            page_name = page_name.replaceAll(" ", "_");
            return <Draggable onStop={OnDragChange} position={eval("set_default_position")(item.id)}>
              <div id={item.id}>
                <button
                  style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                  onClick={delete_btn_click}
                  className="all_2_delete_btn"
                >
                  Delete
                </button>

                <button className="q3_btn_link_w_1">
                  <Link disabled={true} to={"#"}>{page_name2} <i className="fa fa-arrow-right"></i></Link>
                </button>
              </div>
            </Draggable>
          })}

          {labels_.map((item, index) => {
            if (props.tag_values && props.tag_values.length > 0) {

              var değer = props.tag_values
                .filter(
                  (x) => String(x.tagId) === String(item.tagId)
                )
                .map((a) => a.tagValue);
              değer = değer[0].replaceAll(",", ".");
              değer = Number(değer).toFixed(2);
              değer = Number(değer)


              var max = Number(item.max);
              var min = Number(item.min);

              var percent = ((değer - min) / (max - min)) * 100;
              var bgcolor = item.alarm ? (percent <= item.alarm ? "#ffa600" : "brown") : (percent <= 60 ? "#ffa600" : "brown")

            }
            return <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange} >
              <div id={item.id}>
                <button
                  style={{
                    padding: "8px",
                    fontSize: "smaller",
                    top: "-20px"
                  }}
                  onClick={delete_btn_click}
                  className="all_2_delete_btn"
                >
                  Delete
                </button>
                <div className="main_label" >
                  {item.main_title !== "" ? <h5 style={{ margin: "12px 0", fontWeight: "600", color: "rgb(40,40,40)" }} className='main_titile_label_widget'>{item.main_title}</h5> : ""}
                  <span>{item.text} </span>
                  <div className="bottom_progresxwer">
                    <div
                      style={{ height: "auto" }}
                      className="proggress_bar_default"
                    >
                      <div
                        title={`Değer: ${değer}`}
                        style={{
                          textAlign: "center",
                          color: "white",
                          padding: "8px 0",
                          fontWeight: "600",
                          fontSize: "11px",
                          backgroundColor: `${bgcolor}`,
                          width: `${percent}%`,
                          borderRadius: "50px",
                        }}
                      >
                        {değer}
                      </div>

                    </div>
                    {item.led === "true" ? (
                      <input className="led_checkbox" type="checkbox" />
                    ) : (
                      <input
                        className="led_checkbox"
                        type="checkbox"
                        style={{ backgroundColor: "red" }}
                      />
                    )}
                  </div>

                </div>
              </div>
            </Draggable>
          })}

          {tag_btn.map((item, index) => {
            return (
              <Draggable onStop={OnDragChange} position={eval("set_default_position")(item.id)}  >
                <div id={item.id}>
                  <button
                    style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>

                  <span style={{ display: "block", width: "100px" }} id="tag_select">{item.tagName}</span>
                </div>
              </Draggable>
            )
          })}

          {title_w.map((item, index) => {
            console.log(item);
            return (
              <Draggable onStop={OnDragChange} position={eval("set_default_position")(item.id)}>
                <div id={item.id}>
                  <button style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>
                  <input style={{
                    backgroundColor: "white",
                    border: "none",
                    userSelect: "none"
                  }}

                    type="text"
                    value={
                      item.title_widget !== ""
                        ? item.title_widget
                        : undefined
                    }
                    className="drag-input-title-all2edit"
                  />
                </div>
              </Draggable>
            )
          })}

          {text_box.map((item, index) => {
            return (
              <Draggable onStop={OnDragChange} position={eval("set_default_position")(item.id)}>
                <div id={item.id}>
                  <button style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>

                  <span id={item.id} className='w_text_box_span'><input value={item.elementDetails.text} className='w_text_box_inp' /></span>
                </div></Draggable>
            )
          })}

          {tag_flex_column.map((item, index) => {
            console.log(item);
            if (props.tag_values && props.tag_values.length > 0) {

              var değer = props.tag_values
                .filter(
                  (x) => String(x.tagId) === String(item.elementDetails.tagId)
                )
                .map((a) => a.tagValue);
              if (değer.length > 0) {
                console.log(değer);
                değer = değer[0].replaceAll(",", ".");
                değer = Number(değer).toFixed(2);
                değer = Number(değer)
                console.log(değer);
              }
              console.log(değer);
            }
            return (
              <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                <div id={item.id}>
                  <button style={{ position: "absolute", top: "-40%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>
                  <div className={`tag_${item.id}`} id={item.id}>
                    <div className="tag_ws3_flex_column">
                      <p style={{ fontWeight: "700" }}>{item.elementDetails.text}</p>
                      <p className='p_tag_value_TAG'>{değer}</p>

                    </div>
                  </div></div>

              </Draggable>
            )
          })}


          {button2.map((item, index) => {
            console.log(item);
            return (
              <Draggable position={eval("set_default_position")(item.id)} onStop={OnDragChange}>
                <div id={item.id}>
                  <button style={{ position: "absolute", top: "-100%", fontSize: "11px", padding: "4px", zIndex: "100000000000000000000000000" }}
                    onClick={delete_btn_click}
                    className="all_2_delete_btn"
                  >
                    Delete
                  </button>
                  <button onClick={() => {
                    get_tag_value_btn(item.elementDetails.tagId)
                    var temp_arr = []
                    temp_arr.push(item.elementDetails.pop_up)
                    Set_pop_up_widget(temp_arr)
                    document.querySelector(".vrf_detail_popup").classList.toggle("vrf_detail_popup_active")

                  }} className="btn2_class_">{item.elementDetails.text}</button>
                </div>
              </Draggable>
            )
          })}


          <div>{
            white_spaces.map((item_, index_) => {
              console.log(white_spaces);
              return (
                <Draggable onStop={OnDragChange} position={{ x: item_.x, y: item_.y }}>
                  <div id={item_.id} className="card-body_white_paper white_space">
                    <button
                      style={{
                        padding: "12px 16px",
                        fontSize: "smaller",
                        top: "-32px"
                      }}
                      onClick={delete_btn_click}
                      className="all_2_delete_btn"
                    >
                      Delete
                    </button>
                    <div className="white_paper_xs">
                      <div>{item_.elementDetails.map((item, index) => {
                        if (item.type === "title") {
                          return <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                            <div id={item.id}>
                              <input style={{
                                backgroundColor: "transparent",
                                border: "none"
                              }}

                                type="text"
                                value={
                                  item.elementDetails.text !== ""
                                    ? item.elementDetails.text
                                    : undefined
                                }
                                className="drag-input-title"
                              />
                            </div>
                          </Draggable>
                        }
                        if (item.type === "text") {
                          return <Draggable position={{ x: item.x, y: item.y }} disabled={true} >
                            <div id={item.id}><input style={{ backgroundColor: "white", width: "40%" }} type="text" className='drag-input-text-white' value={item.elementDetails.text} /></div>

                          </Draggable>
                        }
                        if (item.type === "led") {
                          let color = "green";
                          if (item.elementDetails.color) {
                            color = item.elementDetails.color;
                          }

                          return (
                            <Draggable position={{ x: item.x, y: item.y }} disabled={true}>
                              <div style={{ display: "inline-block" }} id={item.id}><input style={{ backgroundColor: color }} type="checkbox" id='white_space_led' /></div>
                            </Draggable>
                          )
                        }
                        if (item.type === "label") {
                          return (
                            <Draggable position={{ x: item.x, y: item.y }} disabled={true} >
                              <div id={item.id} className="main_label">
                                {item.main_title !== "" ? <h5 style={{ display: "block", height: "20px", margin: "0" }} className='main_titile_label_widget'>{item.main_title}</h5> : ""}
                                <span>{item.text} {item.led === "true" ? <input className="led_checkbox" type="checkbox" /> : <input className="led_checkbox" type="checkbox" style={{ backgroundColor: "red" }} />}</span>
                                <div style={{ height: "auto" }} className="proggress_bar_default">

                                  <div title={`Değer: 100`} style={{ textAlign: "center", color: "white", padding: "8px 0", fontWeight: "600", height: "100%", fontSize: "11px", backgroundColor: "red", width: `60%`, borderRadius: "8px" }}>
                                    100
                                  </div>
                                </div>
                              </div>
                            </Draggable>
                          )
                        }
                        if (item.type === "gauge") {
                          console.log(item);
                          var percent = Number(Number(props.tag_values.filter(x => String(x.tagId) === String(item.elementDetails.id)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))) / Number(item.elementDetails.max_value))
                          var değer = props.tag_values.filter(x => String(x.tagId) === String(item.elementDetails.tagId)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))

                          let tag_name;
                          if (item.elementDetails.tagName.length > 20) {
                            tag_name = item.elementDetails.tagName.slice(0, 17)
                          }
                          return (
                            <div>

                              <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                                <div className='gauge_widget_tool annanei' id={item.id} >

                                  <div style={{ maxWidth: "100px", backgroundColor: "rgb(240,240,240)", border: "2px solid rgb(40,40,40)", padding: "4px 0px" }} className='gauge_widget_tool' id={index}>
                                    <GaugeChart style={{ maxWidth: "100px" }} arcColor={getGaugeColor(percent)} id="gauge-chart" percent={percent} {...gaugeConfig} />
                                    <div className="gauge_values_display_page_toolbox">
                                      <span>0</span>
                                      <span>{değer[0]}</span>
                                      <span>{item.elementDetails.max_value}</span>
                                    </div>
                                    <span className="w_gauge_name_tag">{tag_name}</span>

                                  </div>
                                </div>
                              </Draggable>
                            </div>
                          )
                        }
                        if (item.type === "button") {
                          return <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                            <div id={item.id} name="button_link_select" className="button_link_select">
                              <Link >{item.elementDetails.text}</Link>
                            </div>

                          </Draggable>
                        }
                        if (item.type === "select") {
                          return <Draggable position={{ x: item.x, y: item.y }} disabled={true} >
                            <div id={item.id}><select name="tag_select" id="tag_select">
                              <option key={"1"} value={item.elementDetails.id}>{item.elementDetails.text}</option>

                            </select></div>

                          </Draggable>
                        }
                        if (item.type === "text_box") {
                          return (
                            <Draggable position={{ x: item.x, y: item.y }} disabled={true}>
                              <span id={item.id} className='w_text_box_span'><input disabled={true} value={item.elementDetails.text} className='w_text_box_inp' /></span>
                            </Draggable>
                          )
                        }
                      })}</div>
                    </div>
                  </div>
                </Draggable>
              )
            })
          }</div>

          <div className="vrf_detail_popup">
            <div>
              {pop_up_widget.map((item_, index) => {
                console.log(item_);
                return (
                  <div className="card-body_white_paper white_space">
                    <i onClick={close_vrf_pop_up} style={{ cursor: "pointer", backgroundColor: "white", borderRadius: "26px", width: "26px", height: "26px", padding: "4px", display: "flex", alignItems: "center", marginBottom: "8px", justifyContent: "center", position: "relative", cursor: "pointer", left: "93%", top: "-260px", color: "red", fontWeight: "600", fontSize: "22px", cursor: "pointer" }} className="fa fa-times"></i>
                    <div id={item_.id} className="white_paper_xs_3_big">

                      <div>
                        {item_.elementDetails.map((item, index) => {
                          console.log(item);
                          if (item.type === "text") {
                            return (
                              <Draggable
                                position={{ x: item.x, y: item.y }}
                                disabled={true}
                              >
                                <div id={item.id}>
                                  <input
                                    style={{
                                      backgroundColor: "white",
                                      width: "40%",
                                    }}
                                    type="text"
                                    className="drag-input-text"
                                    value={item.elementDetails.text}
                                  />
                                </div>
                              </Draggable>
                            );
                          }
                          if (item.type === "title") {
                            console.log(item);
                            return (
                              <Draggable
                                disabled={true}
                                position={{ x: item.x, y: item.y }}
                              >
                                <div id={item.id}>
                                  <input
                                    style={{
                                      backgroundColor: "white",
                                    }}

                                    type="text"
                                    value={
                                      item.elementDetails.text !==
                                        ""
                                        ? item.elementDetails.text
                                        : undefined
                                    }
                                    className="drag-input-title"
                                  />
                                </div>
                              </Draggable>
                            );
                          }
                          if (item.type === "label") {
                            return (
                              <Draggable
                                position={{ x: item.x, y: item.y }}
                                disabled={true}
                              >
                                <div
                                  id={item.id}
                                  className="main_label"
                                >
                                  {item.main_title !== "" ? (
                                    <h5
                                      style={{
                                        display: "block",
                                        height: "20px",
                                        margin: "0",
                                      }}
                                      className="main_titile_label_widget"
                                    >
                                      {item.main_title}
                                    </h5>
                                  ) : (
                                    ""
                                  )}
                                  <span>
                                    {item.text}{" "}
                                    {item.led === "true" ? (
                                      <input
                                        className="led_checkbox"
                                        type="checkbox"
                                      />
                                    ) : (
                                      <input
                                        className="led_checkbox"
                                        type="checkbox"
                                        style={{
                                          backgroundColor: "red",
                                        }}
                                      />
                                    )}
                                  </span>
                                  <div
                                    style={{ height: "auto" }}
                                    className="proggress_bar_default"
                                  >
                                    <div
                                      title={`Değer: 100`}
                                      style={{
                                        textAlign: "center",
                                        color: "white",
                                        padding: "8px 0",
                                        fontWeight: "600",
                                        height: "100%",
                                        fontSize: "11px",
                                        backgroundColor: "red",
                                        width: `60%`,
                                        borderRadius: "8px",
                                      }}
                                    >
                                      100
                                    </div>
                                  </div>
                                </div>
                              </Draggable>
                            );
                          }
                          if (item.type === "led") {
                            let color = "green";
                            if (item.elementDetails.color) {
                              color = item.elementDetails.color;
                            }
                            return (
                              <Draggable
                                position={{ x: item.x, y: item.y }}
                                disabled={true}
                              >
                                <div id={item.id}>
                                  <input
                                    style={{
                                      backgroundColor: color,
                                    }}
                                    type="checkbox"
                                    id="white_space_led"
                                  />
                                </div>
                              </Draggable>
                            );
                          }
                          if (item.type === "gauge") {
                            var percent = Number(

                              Number(props.tag_values.filter((x) => String(x.tagId) === String(item.elementDetails.tagId)).map((x) =>
                                Number(x.tagValue.replaceAll(",", ".")).toFixed(2))) / Number(item.elementDetails.max_value)
                            );
                            var değer = props.tag_values
                              .filter(
                                (x) =>
                                  String(x.tagId) ===
                                  String(item.elementDetails.tagId)
                              )
                              .map((x) =>
                                Number(
                                  x.tagValue.replaceAll(",", ".")
                                ).toFixed(2)
                              );
                            console.log(percent, değer);
                            return (
                              <div>
                                <Draggable
                                  disabled={true}
                                  position={{
                                    x: item.x,
                                    y: item.y,
                                  }}
                                >
                                  <div
                                    className="gauge_widget_tool"
                                    id={item.id}
                                  >
                                    <div
                                      style={{
                                        maxWidth: "100px",
                                        backgroundColor:
                                          "rgb(240,240,240)",
                                        border:
                                          "2px solid rgb(40,40,40)",
                                        padding: "4px 0px",
                                      }}
                                      className="gauge_widget_tool"
                                      id={item.id}
                                    >
                                      <GaugeChart
                                        style={{
                                          maxWidth: "100px",
                                        }}
                                        arcColor={getGaugeColor(
                                          percent
                                        )}
                                        id="gauge-chart"
                                        percent={percent}
                                        {...gaugeConfig}
                                      />
                                      <div className="gauge_values_display_page_toolbox">
                                        <span>0</span>
                                        <span>{değer}</span>
                                        <span>
                                          {
                                            item.elementDetails
                                              .max_value
                                          }
                                        </span>
                                      </div>
                                      <span className="w_gauge_name_tag">{item.elementDetails.tagName}</span>
                                    </div>
                                  </div>
                                </Draggable>
                              </div>
                            );
                          }
                          if (item.type === "button") {
                            return (
                              <Draggable
                                disabled={true}
                                position={{ x: item.x, y: item.y }}
                              >
                                <select
                                  id={item.id}
                                  name="button_link_select"
                                  className="button_link_select"
                                >
                                  {props.pages.map((item) => {
                                    return (
                                      <option value={index}>
                                        {item.pageName}
                                      </option>
                                    );
                                  })}
                                </select>
                              </Draggable>
                            );
                          }
                          if (item.type === "select") {
                            return (
                              <Draggable
                                position={{ x: item.x, y: item.y }}
                                disabled={true}
                              >
                                <div id={item.id}>
                                  <select
                                    name="tag_select"
                                    id="tag_select"
                                  >
                                    <option
                                      key={"1"}
                                      value={item.elementDetails.id}
                                    >
                                      {item.elementDetails.text}
                                    </option>
                                  </select>
                                </div>
                              </Draggable>
                            );
                          }
                          if (item.type === "text_box") {
                            return (
                              <Draggable
                                disabled={true}
                                position={{ x: item.x, y: item.y }}
                              >
                                <span
                                  id={item.id}
                                  className="w_text_box_span"
                                >
                                  <input
                                    value={item.elementDetails.text}
                                    disabled={true}
                                    className="w_text_box_inp"
                                  />
                                </span>
                              </Draggable>
                            );
                          }
                          if (item.type === "tag") {
                            var değer = props.tag_values.filter(x => String(x.tagId) === String(item.elementDetails.tagId)).map(x => Number(x.tagValue.replaceAll(",", ".")).toFixed(2))

                            return <Draggable disabled={true} position={{ x: item.x, y: item.y }}>
                              <div className={`tag_${item.id}`} id={item.id}>
                                <div className="tag_ws3">
                                  <p style={{ marginRight: "12px" }}>{item.elementDetails.text}</p>
                                  <p className='p_tag_value_TAG'>{değer}</p>

                                </div>
                              </div>

                            </Draggable>
                          }
                        })}
                      </div>
                    </div>
                  </div>
                )

              })}

            </div>
          </div>

          <div className={"save_edit_changes_p"}>
            <button onClick={saveTheChangesOfEdit}>Save Changes</button>
          </div>
        </section>
      )}
    </>
  );
};


const MapStateToProps = (state) => {
  return {
    pages__: state.project_reducer.pages,
    pages_names: state.project_reducer.pages_names,
    auth_reducer: state.auth_reducer.user_id,
    company_id: state.project_reducer.company_id,
    tag_ids: state.project_reducer.tag_ids,
    tag_values: state.project_reducer.tag_values,
    tag_list: state.project_reducer.tag_list,
  };
};

export default connect(MapStateToProps)(All2Edit);
